
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Component({
  components: {
    LazyImg
  }
})
export default class extends Vue {
  @Prop() dataSource

  showMask: boolean = false

  handleViewPic() {
    this.$showViewer(this.$images.live_material_img)
  }

  handleJdh() {
    window.open('https://mp.weixin.qq.com/s/VBRIKUI3tTTRCWJ25I4aRw')
  }

  handleTree() {
    window.open('https://mp.weixin.qq.com/s/abOB7tVOUVRF9S7W3QigzQ')
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
